module.exports = __webpack_public_path__ + "static/media/thanks-you.152484b5.png";